import React, { useMemo } from 'react';
import Heading from './Heading';

interface IProps {
    value: string | number;
    contentStyle?: string;
}

const ROLLING_NUM_LIST = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export const RollingNumbers = ({ value, contentStyle }: IProps) => {
  const splittedValue = useMemo(() => {
    if (!value) return [''];
    return value.toString().split('');
  }, [value]);

  return (
    <div className='flex items-center gap-[0px]'>
      {splittedValue.map((v:string, idx:number) => {
        if (!Number.isNaN(Number(v))) {
          return (
          // eslint-disable-next-line react/no-array-index-key
            <div key={`${v}-${idx}`} className='relative flex items-center justify-center overflow-hidden min-w-[13px] w-[13px]'>
              <Heading title={v} className={`${contentStyle ?? ''} opacity-0 animate-delayAppearance`} />
              <div className={`absolute bottom-0 flex flex-col ${idx % 2 === 0 ? 'animate-rollListFromBottom' : 'animate-rollListFromBottomSlow'}`}>
                {ROLLING_NUM_LIST
                  .sort(() => 0.5 - Math.random())
                // eslint-disable-next-line react/no-array-index-key
                  .map((n, nIdx) => <Heading key={`${n}-${nIdx}`} title={n} className={contentStyle ?? ''} />)}
              </div>
            </div>
          );
        }
        // eslint-disable-next-line react/no-array-index-key
        return <Heading key={`${v}-${idx}`} title={v} className={contentStyle ?? ''} />;
      })}
    </div>
  );
};
